import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import Artkey from "./pages/products/artkey"
import Policy from "./pages/products/policy"
import Corpus from "./pages/products/corpus"
import Agreement from './pages/userbs/agreement';
import Login from "./pages/login"
import Hottext from './pages/products/hotText';
import { BrowserRouter, Routes, Route} from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      {/* 开发用，并容错特殊情况 */}
      <Route path="/" element={<App />} />
      {/* 部署到服务器后，地址为 https://app.moxidata.cn/forest/，需要加上forest路径 */}
      <Route path="forest" element={<App />} />
      <Route path="forest/login" element={<Login />} />
      <Route path="forest/artkey" element={<Artkey />} />
      <Route path="forest/policy" element={<Policy />} />
      <Route path="forest/corpus" element={<Corpus />} />
      <Route path="forest/hottext" element={<Hottext />} />
      <Route path="forest/agreement" element={<Agreement />} />

      <Route
        path="*"
        element={
          <main style={{ padding: "1rem" ,textAlign:"center"}}><h1>404 error!</h1></main>
        }
      />
    </Routes>
  </BrowserRouter>,
  document.getElementById('root')
);
reportWebVitals();
